import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './UserHeader.css';

export default function UserHeader({ user, userProfile, onSignOut }) {
    const [isEditingName, setIsEditingName] = useState(false);
    const [editName, setEditName] = useState(userProfile?.name || '');
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    // Sync editName with profile
    useEffect(() => {
        if (userProfile?.name) {
            setEditName(userProfile.name);
        }
    }, [userProfile]);

    // Scroll listener for mobile visibility
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            // On mobile (width < 768px), show on scroll up, hide on scroll down
            if (window.innerWidth < 768) {
                if (currentScrollY > lastScrollY && currentScrollY > 50) {
                    setIsVisible(false); // Scrolling down
                } else {
                    setIsVisible(true); // Scrolling up
                }
            } else {
                setIsVisible(true); // Always visible on desktop
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    const handleSaveName = async (e) => {
        e.preventDefault();
        if (editName.trim() && editName !== userProfile?.name) {
            try {
                await setDoc(doc(db, 'users', user.uid), {
                    name: editName.trim()
                }, { merge: true });
                setIsEditingName(false);
            } catch (err) {
                console.error("Error updating name:", err);
                alert("Failed to update name");
            }
        } else {
            setIsEditingName(false);
        }
    };

    if (!user) return null;

    return (
        <header className={`global-header ${isVisible ? 'visible' : 'hidden'}`}>
            <div className="header-content">
                <Link to="/" className="header-logo">
                    <span className="logo-emoji">🎉</span>
                    <span className="logo-text">Revlry</span>
                    <span className="beta-badge-mini">Beta</span>
                </Link>

                <div className="user-profile-section">
                    {isEditingName ? (
                        <form onSubmit={handleSaveName} className="header-edit-name-form">
                            <input
                                type="text"
                                value={editName}
                                onChange={(e) => setEditName(e.target.value)}
                                autoFocus
                                className="header-edit-name-input"
                                placeholder="Enter your name"
                            />
                            <div className="header-edit-name-actions">
                                <button type="submit" className="header-save-name-btn">Save</button>
                                <button type="button" onClick={() => setIsEditingName(false)} className="header-cancel-name-btn">Cancel</button>
                            </div>
                        </form>
                    ) : (
                        <div className="header-greeting-container">
                            <span className="header-greeting">Hi, {userProfile?.name || 'Friend'}!</span>
                            <button onClick={() => setIsEditingName(true)} className="header-edit-name-icon-btn" title="Edit Name">✏️</button>
                        </div>
                    )}
                    <button onClick={onSignOut} className="header-signout-btn">Sign Out</button>
                </div>
            </div>
        </header>
    );
}
